var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99919 15.0465L13.3593 16.8902C14.0142 17.2508 14.7772 16.6677 14.653 15.9077L14.011 11.9996L16.7291 9.23413C17.2598 8.69654 16.9662 7.75617 16.2355 7.64663L12.4785 7.07702L10.7993 3.51948C10.4718 2.82684 9.52655 2.82684 9.2007 3.51948L7.52146 7.07702L3.76453 7.64663C3.03379 7.75786 2.74021 8.69654 3.27092 9.23413L5.98901 11.9996L5.34538 15.9094C5.22117 16.6694 5.98417 17.2491 6.63909 16.8919L9.99919 15.0482",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackStar);
export default __webpack_public_path__ + "static/media/black-star.abc2f6a26845706bef8eb8cec9019740.svg";
export { ForwardRef as ReactComponent };